var React = require('react');

function Invoice12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 12L4 10.5L6 12L8 10.5L10 12V2.5L7.5 0H2V12ZM4 3H8V5H4V3ZM7 6H4V8H7V6Z","fill":"currentColor"}));
}

Invoice12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Invoice12;

Invoice12.default = Invoice12;
